import classNames from 'classnames'
import styles from './Badge.module.css'
import { BadgeProps } from './types'

function Badge({ kind = 'default', children, className, as = 'div', id }: BadgeProps) {
  const Tag = as
  return (
    <Tag className={classNames(styles.container, styles[kind], className)} id={id}>
      {children}
    </Tag>
  )
}

export default Badge
